export const FETCH_WAREHOUSES_REQUEST = "FETCH_WAREHOUSES_REQUEST"
export const FETCH_WAREHOUSES_SUCCESS = "FETCH_WAREHOUSES_SUCCESS"
export const FETCH_WAREHOUSES_FAILED = "FETCH_WAREHOUSES_FAILED"